import { get } from '@/api/axios';
import { UiConfigEndpoints } from '@/api/endpoints/UiConfigEndpoints';
import { type InterfaceAppearanceDto } from '@/app/models/InterfaceAppearanceDto';

export const getDetails = () => get<InterfaceAppearanceDto>(UiConfigEndpoints.appearance);
